import React from 'react';
import GenericNomenclatureList from './GenericNomenclatureList';
import { useProtocolTypeMutations, useProtocolCategories } from '../../../hooks/useNomenclatures';

const ProtocolTypeList = ({ items, onUpdate }) => {
  const mutations = useProtocolTypeMutations();
  const { items: categories } = useProtocolCategories();

  const fields = [
    { 
      name: 'categoryId', 
      label: 'Category', 
      type: 'select', 
      options: categories.map(cat => ({ value: cat.code, label: cat.name })),
      required: true 
    },
    { name: 'icon', label: 'Icon', type: 'text', placeholder: '🧼' },
    { name: 'color', label: 'Color', type: 'color' }
  ];

  return (
    <GenericNomenclatureList
      items={items}
      type="protocol-types"
      title="Protocol Types"
      fields={fields}
      mutations={mutations}
      onUpdate={onUpdate}
      categories={categories}
    />
  );
};

export default ProtocolTypeList;
